<!DOCTYPE html>
<html>
<head>
    <title>Política de privacidad Jeanologia Market Place</title>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
</head>
<body>
<div class="container">
    <div class="row">
        <div class="col animated fadeIn">
            <div class="w-100 d-flex flex-row justify-content-center align-items-center" style="margin-top: 50px !important;">
            <h2 class="title">
                {{ 'privacy-policy.title' | translate }}
            </h2>
            </div>
            <div class="updateDate">
                {{ 'privacy-policy.update-date' | translate }}
            </div>
            <h3 class="heading">
                {{ 'privacy-policy.heading-1' | translate }}
            </h3>
            <div class="description" [innerHTML]="'privacy-policy.description-1' | translate"></div>
            <h3 class="heading">
                {{ 'privacy-policy.heading-2' | translate }}
            </h3>
            <div class="description" [innerHTML]="'privacy-policy.description-2' | translate">
                <ul>
                    <li [innerHTML]="'privacy-policy.description-2-i' | translate"></li>
                    <li [innerHTML]="'privacy-policy.description-2-ii' | translate"></li>
                </ul>
            </div>
            <h3 class="heading">
                {{ 'privacy-policy.heading-3' | translate }}
            </h3>
            <div class="description">
                {{ 'privacy-policy.description-3' | translate }}
                <ul>
                    <li [innerHTML]="'privacy-policy.description-3-i' | translate"></li>
                    <li [innerHTML]="'privacy-policy.description-3-ii' | translate"></li>
                    <li [innerHTML]="'privacy-policy.description-3-iii' | translate"></li>
                    <li [innerHTML]="'privacy-policy.description-3-iv' | translate"></li>
                </ul>
            </div>
            <h3 class="heading">
                {{ 'privacy-policy.heading-4' | translate }}
            </h3>
            <div class="description">
                {{ 'privacy-policy.description-4' | translate }}

                <p [innerHTML]="'privacy-policy.description-4-i' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-4-ii' | translate"></p>

                {{ 'privacy-policy.description-4-p2' | translate }}
                <p [innerHTML]="'privacy-policy.description-4-p2i' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-4-p2ii' | translate"></p>
            </div>
            <h3 class="heading">
                {{ 'privacy-policy.heading-5' | translate }}
            </h3>
            <div class="description">
                <p [innerHTML]="'privacy-policy.description-5-i' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-5-ii' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-5-iii' | translate"></p>

                <p>{{ 'privacy-policy.description-5-iv' | translate }} <a
                        href="https://www.privacyshield.gov/participant?id=a2zt0000000KzNaAAK&status=Active">https://www.privacyshield.gov/participant?id=a2zt0000000KzNaAAK&status=Active</a>
                </p>
            </div>
            <h3 class="heading">
                {{ 'privacy-policy.heading-6' | translate }}
            </h3>
            <div class="description">
                {{ 'privacy-policy.description-6' | translate }}
                <p [innerHTML]="'privacy-policy.description-6-i' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-6-ii' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-6-iii' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-6-iv' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-6-v' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-6-vi' | translate"></p>
                <p [innerHTML]="'privacy-policy.description-6-vii' | translate"></p>
                <p>{{ 'privacy-policy.description-p1' | translate }} </p>
                <p>{{ 'privacy-policy.description-p2' | translate }} </p>

                <p>
                    {{ 'privacy-policy.description-p2-i' | translate }} <a
                        href="mailto:info@jeanologia.com">info&#64;jeanologia.com</a>, {{
                    'privacy-policy.description-p2-ii' | translate }}
                </p>

                <p>
                    {{ 'privacy-policy.description-p3' | translate }}
                </p>

                <p>
                    {{ 'privacy-policy.description-p4' | translate }}
                </p>
            </div>
            <div class="footer">
                {{ 'privacy-policy.footer' | translate }}
            </div>
        </div>
    </div>
</div>
</body>

</html>
